
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <table class="form-group form-group-sm" *ngIf="personnages">
              <tr><th>Joueur</th><th>Personnage</th><th>Crimson</th></tr>
              <tr *ngFor="let personnage of personnages">
                <td>{{personnage.joueur}}</td>
                <td>{{ personnage.nom }}</td>
                <td>
                  <form (ngSubmit)="onSubmit(personnage.id, crimsonDisponible.value)">
                    <div class="input-group">
                      <input #crimsonDisponible class="form-control" type="text" value="{{personnage.crimsonDisponible}}">
                      <div class="input-group-append">
                        <input class="btn" type="submit" value="Appliquer">
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>